import React, { DetailedHTMLProps, HTMLAttributes, DOMAttributes } from "react";
import ZoomVideo, { AudioChangeAction, Participant, VideoCapturingState, VideoPlayer, VideoPlayerContainer, VideoQuality, ConnectionState } from "@zoom/videosdk";
import { useState, useEffect, useRef } from "react";
import { MediaStream } from "../../core/dto/zoom-video.dto";
import { Button } from "react-bootstrap";
import "./Zoom.css";
import { DisplayErrorMessages, DisplayToaster, RevertFormattedPhoneNumber } from "../../core/services/sharedService";
import { PostApiMethod } from "../../core/services/apiService";
import { setInHandOffCall } from "../../core/redux/notificationsSlice";
import InputMask from "react-input-mask";
import { useParticipantsChange } from "../../hooks/useParticipantChange";
import { usePrevious } from "../../hooks/usePrevious";
import AppModal from "../AppModal/AppModal";
import Teams from "../Teams/Teams";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import { loggerHelper } from "../../core/services/sharedService";
import { setEnableDisableDropDown } from "../../core/redux/notificationsSlice";
import { DtoVideoRoomsProps } from "../../core/dto/dashboard.dto";
import AppLoader from "../AppLoader/AppLoader";
import vrm_large_logo from "../../assets/vrm_large_logo.png";
import AgentStatusInfoTooltip from "./AgentStatusInfoTooltip";

type CustomElement<T> = Partial<T & DOMAttributes<T> & { children: any }>;

declare global {
    namespace JSX {
        interface IntrinsicElements {
            ['video-player']: DetailedHTMLProps<HTMLAttributes<VideoPlayer>, VideoPlayer> & { class?: string };
            ['video-player-container']: CustomElement<VideoPlayerContainer> & { class?: string };
        }
    }
}

const ZoomVideoRoom = ({
    setLocalParticipantInfo,
    twilioToken,
    roomName,
    roomSid,
    terminateVideoCallRef,
    terminateVideoCall,
    locationId,
    notificationId,
    agentId,
    isKiosk = false,
    isHandOffRoom = false,
    isQrTenantRoom = false,
    putCallOnHold,
    addParticipant,
    addParticipantVideoCall,
    isQrScanNotification = false,
    terminateHandOffCall,
    holdVideoCallRef,
    terminateQrRoomCall,
    sessionName,
    userName,
    remoteParticipantConnectedFun,
    agentName
}: any) => {

    const kioskColorInfo = React.useRef<{ [index: string]: string }>();
    const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);
    const [zoomVideo, setZoomVideo] = useState<any>(null);
    const [participants, setParticipants] = React.useState<Participant[]>([]);
    const [subscribers, setSubscribers] = React.useState<number[]>([]);
    const videoPlayerListRef = useRef<Record<string, VideoPlayer>>({});
    const previousSubscribers = usePrevious(subscribers);
    const [audioDisable, setAudioDisable] = React.useState(false);
    const [videoDisable, setVideoDisable] = React.useState(false);
    const [zoomLocalParticipant, setZoomLocalParticipant] = React.useState<Participant[]>([]);
    const [timer, setTimer] = React.useState<number>(0);
    const [addThirdUserFlag, setAddThirdUserFlag] = React.useState<boolean>(false);
    const [zoomSessionId, setZoomSessionId] = React.useState<string>("");
    let notificationsSliceSelector = useAppSelector((state) => state.agentNotification);
    const logger = React.useCallback((message: String, details: any) => {
        loggerHelper(message, details);
    }, [])
    const [showPopUp, setShowPopUp] = React.useState<boolean>(false);
    const videoCallHandoffNumberRef = React.useRef<string>();
    const [handOffLoader, setHandOffLoader] = React.useState(false);
    const [handOffContactError, setHandOffContactError] = React.useState<boolean>(false);
    const [contactMinMaxError, setContactMinMaxError] = React.useState<boolean>(false);
    let dispatch = useAppDispatch();
    const [videoCallHandOffNumber, setVideoCallHandOffNumber] = React.useState<any>();
    const [videoOffIcon, setVideoOffIcon] = React.useState<boolean>(false);
    let zoomToken = twilioToken;
    // const videoContainer = document.querySelector('video-player-container');
    let authState = useAppSelector((state) => state.auth);
    let zmClient = ZoomVideo.createClient();
    // const [cameraList, setCameraList] = React.useState<string>("");

    const connectVideoChat = async () => {
        await zmClient?.init('en-US', 'Global', { patchJsMedia: true, enforceMultipleVideos: true });
        try {
            await zmClient?.join(sessionName, zoomToken, userName).catch((e) => { console.log(e, 'Error while initializing the session') });
            const sessionInfo = zmClient?.getSessionInfo();
            setZoomSessionId(sessionInfo?.sessionId);
            const stream = zmClient?.getMediaStream();
            setMediaStream(stream);
        } catch (e: any) {
            console.log(e, 'e.reason while joining the zoom session ======================>');
        }
    }


    useEffect(() => {
        setZoomVideo(zmClient);
        connectVideoChat();
        return () => {
            ZoomVideo?.destroyClient();
        };
    }, [zoomToken]);

    useEffect(() => {
        try {
            const startVideo = async () => {
                if (mediaStream) {
                    try {
                        await mediaStream?.startVideo();
                        await mediaStream?.startAudio({ highBitrate: true, originalSound: true });
                        setLocalParticipantInfo(zoomVideo?.getCurrentUserInfo().userId);
                    } catch (error) {
                        console.error('Error starting video', error);
                    }
                }
            };

            startVideo();
        } catch (error) {
            console.log("Error while starting the video", error);
        }

    }, [mediaStream]);


    const renderVideo = async (event: any) => {
        try {
            const mediaStream = zoomVideo?.getMediaStream();
            if (event.action === 'Start') {
                const userVideo = await mediaStream?.attachVideo(event.userId, VideoQuality.Video_360P);
                // userVideo?.classList.add("video-cell");
                // videoContainer?.appendChild(userVideo);
            }
            else {
                const element = await mediaStream?.detachVideo(event.userId);
                Array.isArray(element) ? element.forEach((el) => el.remove()) : element.remove();
            }
        } catch (error) {
            console.log("Error in the render video function", error);
        }

    };

    useEffect(() => {
        try {
            if (zoomVideo) {
                zoomVideo?.on('user-added', (res: any) => {
                    if (res[0].userIdentity.includes("tenant_")) {
                        if (isKiosk) {
                            zoomVideo.leave();
                        }
                    }
                    if (res[0].userIdentity.includes("agent_")) {
                        if (isQrTenantRoom) {
                            remoteParticipantConnectedFun(true);
                        }
                    }
                });

                zoomVideo?.on('connection-change', (res: any) => {
                    if (res.state === ConnectionState.Closed && res.reason === "ended by host") {
                        if (isKiosk) {
                            zoomVideo?.leave();
                        }
                        if (isHandOffRoom) {
                            zoomVideo?.leave();
                            endHandOffVideoCall(false, true);
                        }
                        if (isQrTenantRoom) {
                            zoomVideo?.leave();
                            terminateQrRoomCall(false, "ended by host");
                        }
                    }
                });
                return () => {
                    zoomVideo?.off('user-added', () => { });
                };
            }
        } catch (error) {
            console.log("Error ==========================>", error);
        }
    }, [zoomVideo]);


    useEffect(() => {
        try {
            const addedUsers = subscribers.filter((user) => !(previousSubscribers || []).includes(user));
            const removedUsers = (previousSubscribers || []).filter((user: any) => !subscribers.includes(user));
            if (removedUsers.length > 0) {
                removedUsers.forEach((userId: any) => {
                    mediaStream?.detachVideo(userId);
                });
            }
            if (addedUsers.length > 0) {
                addedUsers.forEach((userId) => {
                    const attachment = videoPlayerListRef.current[`${userId}`];
                    if (attachment) {
                        mediaStream?.attachVideo(userId, VideoQuality.Video_720P, attachment);
                    }
                });
            }
        } catch (error) {
            console.log("Error while attaching the joined user video ==========================>", error);
        }
    }, [subscribers, previousSubscribers, mediaStream]);


    const onVideoCaptureChange = React.useCallback((payload: any) => {
        try {
            if (payload.state === VideoCapturingState.Started) {
                setVideoDisable(false);
            } else {
                setVideoDisable(true);
            }
        } catch (error) {
            console.log("Error while onVideoCaptureChange of user video ==========================>", error);
        }

    }, []);

    const onAudioStateChange = React.useCallback((payload: any) => {
        try {
            const { action, source, type } = payload;
            if (action === AudioChangeAction.Muted) {
                setAudioDisable(true);
            } else if (action === AudioChangeAction.Unmuted) {
                setAudioDisable(false);
            }
        } catch (error) {
            console.log("Error while onAudioStateChange of user Audio ==========================>", error);
        }

    }, []);

    React.useEffect(() => {
        try {
            zoomVideo?.on('video-capturing-change', onVideoCaptureChange);
            zoomVideo?.on('current-audio-change', onAudioStateChange);
            zoomVideo?.on('connection-change', (payload: any) => {
                if (payload.state === ConnectionState.Closed) {
                    if (!isHandOffRoom && !isKiosk && !isQrTenantRoom) {
                        zoomVideo?.leave();
                        setLocalParticipantInfo(null);
                    }
                }
            });

            return () => {
                zoomVideo?.off('video-capturing-change', onVideoCaptureChange);
                zoomVideo?.off('current-audio-change', onAudioStateChange);
                zoomVideo?.off('connection-change', (payload: any) => { });
            }
        } catch (error) {
            console.log("Error while changing media stream of the joined user   ==========================>", error);
        }

    }, [zoomVideo, onVideoCaptureChange, onAudioStateChange, isHandOffRoom, isKiosk, isQrTenantRoom, setLocalParticipantInfo]);


    const makeVideoCallHandoff = React.useCallback((e: any) => {
        setHandOffLoader(true);
        if (e)
            e.preventDefault();
        if (!RevertFormattedPhoneNumber(videoCallHandoffNumberRef.current ? videoCallHandoffNumberRef.current : '')) {
            setHandOffLoader(false);
            setHandOffContactError(true);
            return false;
        }
        else if (videoCallHandoffNumberRef.current && (RevertFormattedPhoneNumber(videoCallHandoffNumberRef.current).length < 10 || RevertFormattedPhoneNumber(videoCallHandoffNumberRef.current).length > 11)) {
            setHandOffLoader(false);
            setContactMinMaxError(true);
            return false;
        } else {
            let postData = {
                room_name: roomName,
                contact: RevertFormattedPhoneNumber("1" + videoCallHandoffNumberRef.current),
                location: locationId,
                room_sid: zoomSessionId,
                notification_id: notificationId,
                agent_id: agentId,
            }
            PostApiMethod("tenant/callHandOff/send-link", postData).then((res) => {
                dispatch(setInHandOffCall(locationId));
                if (res.data.status === "Success") {
                    setHandOffLoader(false);
                    DisplayToaster("bg-success", "Hand-off link has been shared to Tenant's contact number successfully!");
                    setShowPopUp(false);
                }
            }).catch((err) => {
                setHandOffLoader(false);
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
                setShowPopUp(false);
            })
            setVideoCallHandOffNumber("");
        }

    }, [agentId, locationId, dispatch, notificationId, roomName, zoomSessionId]);

    useParticipantsChange(zoomVideo, (participants) => {
        try {
            let pageParticipants: Participant[] = [];
            if (participants?.length > 0) {
                if (participants.length === 1) {
                    pageParticipants = participants;
                } else {
                    pageParticipants = participants
                        ?.filter((user) => user.userId !== zoomVideo?.getSessionInfo().userId)
                        .sort((user1, user2) => Number(user2.bVideoOn) - Number(user1.bVideoOn));
                    const currentUser = zoomVideo?.getCurrentUserInfo();
                    if (currentUser) {
                        pageParticipants.splice(1, 0, currentUser);
                    }
                }
            }
            setParticipants(pageParticipants.filter((user) => (user.userId !== zoomVideo?.getCurrentUserInfo().userId)));
            setZoomLocalParticipant(pageParticipants.filter((user) => (user.userId === zoomVideo?.getCurrentUserInfo().userId)));
            setSubscribers(pageParticipants.filter((user) => user.bVideoOn).map((u) => u.userId));
        } catch (error) {
            console.log("Error while attaching the joined user video ==========================>", error);
        }
    });

    React.useEffect(() => {
        let interval: any = 0;
        if (participants.length > 0) {
            interval = setInterval(() => {
                setTimer((perviousTime) => {
                    return perviousTime + 1000;
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval)
        };
    }, [participants]);

    const toggleVideo = async () => {
        try {
            const mediaStream = zoomVideo?.getMediaStream();
            if (mediaStream?.isCapturingVideo()) {
                setVideoOffIcon(true);
                await mediaStream?.stopVideo();
                await renderVideo({ action: 'Stop', userId: zoomVideo?.getCurrentUserInfo().userId });
            } else {
                setVideoOffIcon(false);
                await mediaStream?.startVideo();
                await renderVideo({ action: 'Start', userId: zoomVideo?.getCurrentUserInfo().userId });
            }
        } catch (error) {
            console.log("Error while toggleVideo ==========================>", error);
        }

    };

    // React.useEffect(() => {
    //     setTimeout(() => {
    //         const localMediaStream = zoomVideo?.getMediaStream();
    //         console.log(localMediaStream, 'localMediaStream in setTimeout =============================>');
    //         let isCapturingVideo = localMediaStream?.isCapturingVideo();
    //         console.log(isCapturingVideo, 'isCapturingVideo in setTimeout =====================>');
    //     }, 10000)
    // }, [zoomVideo, mediaStream]);

    React.useEffect(() => {
        const localMediaStream = zoomVideo?.getMediaStream();
        console.log(localMediaStream, 'localMediaStream =============================>');
        let isCapturingVideo = localMediaStream?.isCapturingVideo();
        let isCaptureForbidden = localMediaStream?.isCaptureForbidden();
        let isCameraTaken = localMediaStream?.isCameraTaken();

        console.log(isCapturingVideo, 'isCapturingVideo =====================>');
        console.log(isCaptureForbidden, 'isCaptureForbidden =====================>');
        console.log(isCameraTaken, 'isCameraTaken =====================>');

    }, [zoomVideo, mediaStream])

    const setVideoPlayerRef = (userId: number, element: VideoPlayer | null) => {
        if (element) {
            videoPlayerListRef.current[`${userId}`] = element;
        }
    };

    const endZoomVideoCall = React.useCallback(() => {
        try {
            setLocalParticipantInfo(null);
            zoomVideo?.leave();
            terminateVideoCall(
                notificationId || locationId,
                false,
                notificationId
                    ? "no"
                    : "yes"
            )
        } catch (error) {
            console.error('Error in endZoomVideoCall function', error);
        }
    }, [terminateVideoCall, notificationsSliceSelector.videoRoomDetails, notificationId, locationId, zoomVideo]);



    const addThirdUsers = React.useCallback((agentDetails: any) => {
        logger('videoRoom addThirdUsers trigger agentDetails', agentDetails);
        setAddThirdUserFlag(false);
        addParticipantVideoCall(roomName, agentDetails._id, locationId, zoomSessionId, isQrScanNotification, sessionName ? sessionName : "");
    }, [addParticipantVideoCall, locationId, logger, roomName, zoomSessionId, isQrScanNotification, sessionName]);

    const OnChangeStoreHandOffContact = React.useCallback(
        (event: any) => {
            setVideoCallHandOffNumber(event.target.value);
            setHandOffContactError(false);
            setContactMinMaxError(false);
        },
        [setVideoCallHandOffNumber]
    );

    React.useEffect(() => {
        videoCallHandoffNumberRef.current = videoCallHandOffNumber;
    }, [videoCallHandOffNumber]);


    const endHandOffVideoCall = React.useCallback((value: boolean, isEndedByHost: boolean = false) => {
        // zoomVideo?.leave();
        terminateHandOffCall(value, isEndedByHost);
    }, [zoomVideo]);


    const detachCurrentVideoCall = React.useCallback(() => {
        setLocalParticipantInfo(null);
    }, [setLocalParticipantInfo]);


    React.useEffect(() => {
        terminateVideoCallRef.current = detachCurrentVideoCall;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detachCurrentVideoCall]);

    const handleAudioMute = async () => {
        try {
            const mediaStream = zoomVideo?.getMediaStream();
            if (mediaStream?.isAudioMuted()) {
                await mediaStream?.unmuteAudio();
                setAudioDisable(false);
            } else {
                await mediaStream?.muteAudio();
                setAudioDisable(true);
            }
        } catch (error) {
            console.error('Error in handleAudioMute function', error);
        }

    };

    const leaveRoom = React.useCallback(() => {
        if (zoomVideo) {
            zoomVideo?.leave();
            setLocalParticipantInfo(null);
        }
    }, [zoomVideo, setLocalParticipantInfo])

    React.useEffect(() => {
        if (holdVideoCallRef) {
            holdVideoCallRef.current = leaveRoom;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leaveRoom]);


    const switchMicrophone = React.useCallback(async (deviceId: any) => {
        let stream = zoomVideo?.getMediaStream();
        try {
            await stream?.switchMicrophone(deviceId);
            console.log(`Switched microphone to device with ID: ${deviceId}`);
        } catch (error) {
            console.error('Error switching microphone:', error);
        }
    }, [zoomVideo]);

    const switchSpeaker = React.useCallback(async (deviceId: any) => {
        let stream = zoomVideo?.getMediaStream();
        try {
            await stream?.switchSpeaker(deviceId);
            console.log(`Switched switchSpeaker to device with ID: ${deviceId}`);
        } catch (error) {
            console.error('Error switching switchSpeaker:', error);
        }
    }, [zoomVideo]);


    const switchCamera = React.useCallback(async (deviceId: any) => {
        let stream = zoomVideo?.getMediaStream();
        try {
            await stream?.switchCamera(deviceId);
            console.log(`Switched switchCamera to device with ID: ${deviceId}`);
        } catch (error) {
            console.error('Error switching switchCamera:', error);
        }
    }, [zoomVideo])

    React.useEffect(() => {
        try {
            if (notificationsSliceSelector?.triggersetSinkId) {
                let audioOutputDevice = notificationsSliceSelector?.notificationAudioDevice?.selectedAudioOutputDevice;
                let selectedAudioInputDevice = notificationsSliceSelector?.notificationAudioDevice?.selectedAudioInputDevice;
                if (selectedAudioInputDevice) {
                    switchMicrophone(selectedAudioInputDevice);
                } else if (audioOutputDevice) {
                    switchSpeaker(audioOutputDevice);
                } else if (notificationsSliceSelector?.notificationAudioDevice?.selectedVideoDevice) {
                    switchCamera(notificationsSliceSelector?.notificationAudioDevice?.selectedVideoDevice);
                }
                dispatch(setEnableDisableDropDown(""));
            }
        } catch (error) {
            console.error('Error while setting the selected device choice', error);
        }

    }, [dispatch, notificationsSliceSelector, zoomVideo, switchMicrophone, switchSpeaker, switchCamera]);

    const handleCameraSwap = React.useCallback(() => {
        let stream = zoomVideo?.getMediaStream();
        try {
            let cameraList = stream?.getCameraList();
            let activeCamera = stream?.getActiveCamera();
            // setCameraList(JSON.stringify(cameraList));
            const switchCameraDeviceId = cameraList?.filter((x: any) => x.deviceId !== activeCamera);
            const activeCameraRes = cameraList?.filter((device: any) => device?.deviceId === activeCamera);
            if (activeCameraRes[0]?.label?.toLowerCase().includes("front")) {
                let backCamera = switchCameraDeviceId?.filter((device: any) => device?.label?.toLowerCase().includes("back"));
                if (backCamera?.length > 0) {
                    switchCamera(backCamera[0]?.deviceId);
                }
            } else {
                let frontCamera = switchCameraDeviceId?.filter((device: any) => device?.label?.toLowerCase().includes("front"));
                if (frontCamera?.length > 0) {
                    switchCamera(frontCamera[0]?.deviceId);
                }
            }
        } catch (error) {
            console.log("handleCameraSwap camera : ");
        }
    }, [zoomVideo, switchCamera])


    return (
        <div className='h-100 w-100'>
            {twilioToken ? (

                <div className={`${!isKiosk && ((isQrTenantRoom || isHandOffRoom)) ? 'zoom-qr-room' : 'zoom-agentscreen-video'}`}>
                    {showPopUp &&
                        (<AppModal
                            title="Call hand-off"
                            bodyText=""
                            primaryButtonLabel={"Share"}
                            secondaryButtonLabel={"Cancel"}
                            primaryButtonEventEmitter={(e: any) => makeVideoCallHandoff(e)}
                            secondaryButtonEventEmitter={() => { setShowPopUp(false); setVideoCallHandOffNumber(""); setHandOffContactError(false); setContactMinMaxError(false); }}
                            stayAppear={true}
                            handOffLoader={handOffLoader}
                        >
                            <form className="mt-2" onSubmit={(e) => { makeVideoCallHandoff(e) }}>
                                <div className="row">
                                    <div className="col-sm-6 col-md-6 col-lg-6 mt-1">
                                        <label>Tenant's Contact Number</label><span className="text-danger">*</span>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                                            </div>
                                            <InputMask
                                                type="text"
                                                name="contact"
                                                defaultValue={videoCallHandOffNumber}
                                                onChange={(e) => { OnChangeStoreHandOffContact(e) }}
                                                className="form-control"
                                                mask="(999)-999-99999" maskChar={null}
                                            // onKeyPress={numberOnly}
                                            />
                                        </div>

                                        {handOffContactError && <small className="text-danger">Tenant's Contact Number is required</small>}
                                        {contactMinMaxError && <small className="text-danger">Tenant's Contact Number should be 10 or 11 digits</small>}
                                    </div>
                                </div>
                            </form>
                        </AppModal>
                        )}
                    <div className={isKiosk ? 'align-items-center zoom-video-room-lg zoom-kiosk-parent-section' : 'zoom-video-room-lg align-items-center'} style={{ 'height': 'calc(100vh - 250px)' }}>
                        <video-player-container class={`${(participants && participants.length) > 1 ? "video-container-wrap d-flex" : "video-container-wrap"} `}>

                            <div className={
                                (isKiosk)
                                    ? ((participants && participants.length > 1) ? "multiple-kiosk-video-wrapper kiosk-video-wrapper" : "zoom-single-video-kiosk-sec single-kiosk-video-wrapper kiosk-video-wrapper") :
                                    (isHandOffRoom || isQrTenantRoom) ? (participants && participants.length > 1 ? "zoom-multiple-videos zoom-agent-tenant-multiple-section  tenant-video-wrapper" : "single-tenant-video-wrapper tenant-video-wrapper")
                                        : ((!isKiosk) && participants.length > 1 ? "zoom-multiple-videos zoom-agent-tenant-multiple-section tenant-video-wrapper" : "single-tenant-video-wrapper tenant-video-wrapper")
                            }>
                                {/* <div
                                    className="video-cell"
                                    key={user.userId}
                                > */}

                                {participants.length > 0 ?
                                    participants?.map((user: any) => {
                                        return (
                                            <>
                                                {/* {user.bVideoOn ? "true" : "false"} */}
                                                {user.bVideoOn ?
                                                    <div className='w-100'>
                                                        <video-player
                                                            key={user.userGuid}
                                                            style={user.bVideoOn ? { "aspectRatio": "16/9" } : { "background": "black", "aspectRatio": "1/1" }}
                                                            // className={`video-player ${participants.length > 1 ? 'w-50' : 'w-100'}`}
                                                            className='video-player'
                                                            ref={(element) => {
                                                                setVideoPlayerRef(user.userId, element);
                                                            }}
                                                            node-id={user.userId}
                                                        />
                                                        {/* <span className='lg-remote-video-mute'>{user.muted ? <i className="bi bi-mic-mute"></i> : <></>} </span> */}
                                                    </div>
                                                    : <div className='agent-video-wrapper'><i className="bi bi-camera-video-off" style={{ "color": "white" }}></i></div>
                                                }
                                            </>
                                        );
                                    })


                                    : (
                                        <>
                                            {isKiosk ? (
                                                <div style={{ minWidth: '100%' }}>
                                                    <AppLoader
                                                        removeFixedHeight={true}
                                                        customClassName={
                                                            "kiosk-remote-participant"
                                                        }
                                                        customStyle={kioskColorInfo.current}
                                                    />
                                                </div>
                                            ) : (
                                                <AppLoader />
                                            )}
                                        </>
                                    )}
                                {/* </div> */}
                            </div>

                        </video-player-container>
                    </div>
                    {/* Agent panel code starts */}

                    <div className={
                        (isKiosk)
                            ? " d-flex justify-content-between kioskLocalParticipantVideoCard" :
                            (isHandOffRoom || isQrTenantRoom) ? ""
                                : " d-flex justify-content-between align-items-center zoom-agent-local-participant-section"
                    }>
                        {
                            (!isKiosk && zoomVideo) ? (
                                <>
                                    {/* for Agent Screen and for desktop screen */}
                                    {
                                        !isHandOffRoom && !isQrTenantRoom && <div className={"video-call-action-button-desktop"}>

                                            <div className={" d-flex align-items-center gap-1"}>
                                                <Button
                                                    className=""
                                                    title="End call"
                                                    onClick={() => {
                                                        // eslint-disable-next-line no-lone-blocks
                                                        endZoomVideoCall()
                                                    }}
                                                    variant="danger"
                                                >
                                                    <i className="bi bi-telephone-fill"></i>
                                                </Button>

                                                <Button
                                                    onClick={() => {
                                                        toggleVideo();
                                                    }}
                                                    variant={
                                                        videoDisable
                                                            ? "warning"
                                                            : "secondary"
                                                    }
                                                    title='Enable/Disable video'
                                                >
                                                    <i
                                                        className={
                                                            videoDisable
                                                                ? "bi bi-camera-video-off-fill"
                                                                : "bi bi-camera-video-fill"
                                                        }
                                                    ></i>
                                                </Button>
                                                <Button
                                                    onClick={() => handleAudioMute()}
                                                    title="Mute/Unmute Mic"
                                                    variant={
                                                        audioDisable
                                                            ? "warning"
                                                            : "secondary"
                                                    }
                                                >
                                                    <i
                                                        className={
                                                            audioDisable
                                                                ? "bi bi-mic-mute-fill"
                                                                : "bi bi-mic-fill"
                                                        }
                                                    ></i>
                                                </Button>

                                                {!isQrScanNotification &&
                                                    <Button
                                                        onClick={() => {
                                                            setShowPopUp(true)
                                                        }}
                                                        variant="secondary"
                                                        title="Call hand-off"
                                                    >
                                                        <i className="bi bi-share"></i>
                                                    </Button>
                                                }
                                                {
                                                    (addParticipant) ?

                                                        <div className="btn-tooltip-container">
                                                            <Button
                                                                onClick={() => { setAddThirdUserFlag(true); }}
                                                                variant="secondary"
                                                                // title="Add agent"
                                                                className="btn-tooltip"
                                                            >
                                                                <i className="bi bi-person-plus-fill"></i>

                                                            </Button>

                                                            <AgentStatusInfoTooltip tooltipClass="tooltiptext" />
                                                        </div>
                                                        :
                                                        <></>
                                                }
                                                {
                                                    (!notificationsSliceSelector.holdCallDetails ||
                                                        (
                                                            notificationsSliceSelector?.holdCallDetails?.inCallRefId &&
                                                            notificationsSliceSelector.inCallNotificationIdRef &&
                                                            notificationsSliceSelector.inCallNotificationIdRef ===
                                                            notificationsSliceSelector.holdCallDetails.inCallRefId)) ? (
                                                        <Button
                                                            onClick={() => { putCallOnHold('video'); }}
                                                            variant="secondary"
                                                            title="Hold"
                                                        >
                                                            <i className="bi bi-pause-circle-fill"></i>
                                                        </Button>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <Button
                                                    className="video-timer"
                                                    variant="secondary"
                                                    disabled
                                                >
                                                    {(
                                                        "0" +
                                                        Math.floor((timer / 60000) % 60)
                                                    ).slice(-2)}
                                                    :
                                                    {(
                                                        "0" +
                                                        Math.floor((timer / 1000) % 60)
                                                    ).slice(-2)}
                                                </Button>
                                            </div>
                                        </div>
                                    }

                                    {/* <div className="Test">
                                     {
                                        authState.allAgentStatusDetails.length > 0  ?
                                          authState.allAgentStatusDetails.map((user: any, index: any) => (
                                             <div>
                                                 {TooltipPositioned({
                                                    placement: "top",
                                                    item:
                                                    <div className="online">{user.status === "online" ? user.username : "" }</div>  
                                                   })} 
                                                      { 
                                                      <div className="online">{user.status === "online" ? user.username : "" }</div>   
                                                    } 
                                                </div>
                                            )) : <></>

                                     }
                                    </div>    */}

                                    <video-player-container class="video-container-wrap">
                                        <div className="ml-auto Participant-video-frame">
                                            {zoomLocalParticipant?.map((user: any) => {
                                                return (
                                                    <div
                                                        className="video-cell localParticipantVideoClass video-thumbnail player-mute-icon"
                                                        key={user.userId}
                                                        style={user.bVideoOn ? { "aspectRatio": "16/9" } : { "background": "#6b6e76", "aspectRatio": "16/9" }}
                                                    >
                                                        {user.bVideoOn ?
                                                            <div key={user.userGuid} className='player-icons'>
                                                                <video-player
                                                                    class="video-player localParticipantVideoCard"
                                                                    ref={(element) => {
                                                                        setVideoPlayerRef(user.userId, element);
                                                                    }}
                                                                />
                                                                <span className='position-relative'>{audioDisable ? <i className="bi bi-mic-mute mute-icon"></i> : <></>} </span>
                                                            </div>

                                                            : <i className="bi bi-camera-video-off" style={{ "color": "white" }}></i>
                                                        }
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </video-player-container>

                                    {/* Desktop view for QR-room and hand-off rooms  */}
                                    {/* <div id="test"> cameraList2 :  {cameraList} </div> */}
                                    {
                                        (isHandOffRoom || isQrTenantRoom) &&
                                        <div className='zoom-room-controls video-call-action-button-desktop'>
                                            <Button
                                                title="End call"
                                                onClick={() => {
                                                    isHandOffRoom ? endHandOffVideoCall(true) : terminateQrRoomCall(true)
                                                }}
                                                variant="danger"
                                            >
                                                <i className="bi bi-telephone-fill"></i>
                                            </Button>
                                            <Button
                                                onClick={() => handleAudioMute()}
                                                title="Mute/Unmute Mic"
                                                variant={
                                                    audioDisable
                                                        ? "warning"
                                                        : "secondary"
                                                }
                                            >
                                                <i
                                                    className={
                                                        audioDisable
                                                            ? "bi bi-mic-mute-fill"
                                                            : "bi bi-mic-fill"
                                                    }
                                                ></i>
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    toggleVideo();
                                                }}
                                                variant={
                                                    videoDisable
                                                        ? "warning"
                                                        : "secondary"
                                                }
                                                title='Enable/Disable video'
                                            >
                                                <i
                                                    className={
                                                        videoDisable
                                                            ? "bi bi-camera-video-off-fill"
                                                            : "bi bi-camera-video-fill"
                                                    }
                                                ></i>
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    handleCameraSwap();
                                                }}
                                                variant={"secondary"}
                                                title='Camera swap'
                                            >
                                                <i className="bi bi-phone-flip"></i>
                                            </Button>
                                            <Button
                                                className="video-timer"
                                                variant="secondary"
                                                disabled
                                            >
                                                {" "}
                                                {(
                                                    "0" +
                                                    Math.floor((timer / 60000) % 60)
                                                ).slice(-2)}
                                                :
                                                {(
                                                    "0" +
                                                    Math.floor((timer / 1000) % 60)
                                                ).slice(-2)}
                                            </Button>
                                        </div >
                                    }


                                    {/* Mobile view Starts for local participant video and all the option buttons */}
                                    <div className={(isHandOffRoom || isQrTenantRoom) ? "video-call-action-button-mobile mt-5" : "video-call-action-button-mobile"}>
                                        <div className="d-flex flex-wrap align-items-center justify-content-center zoom-room-controls">
                                            <Button
                                                onClick={() => {
                                                    (!isHandOffRoom && !isQrTenantRoom) ?
                                                        terminateVideoCall(
                                                            notificationId
                                                                ? notificationId
                                                                : locationId,
                                                            false,
                                                            notificationId
                                                                ? "no"
                                                                : "yes"
                                                        ) : (isHandOffRoom ? terminateHandOffCall(true) : terminateQrRoomCall(true))
                                                }}
                                                variant="danger"
                                                title="End call"
                                            >
                                                <i className="bi bi-telephone-fill"></i>
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    handleAudioMute();
                                                }}
                                                variant={
                                                    audioDisable
                                                        ? "warning"
                                                        : "secondary"
                                                }
                                                title="Mic mute / unmute"
                                            >
                                                <i
                                                    className={
                                                        audioDisable
                                                            ? "bi bi-mic-mute-fill"
                                                            : "bi bi-mic-fill"
                                                    }
                                                ></i>
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    toggleVideo();
                                                }}
                                                variant={
                                                    videoDisable
                                                        ? "warning"
                                                        : "secondary"
                                                }
                                                title='Enable/Disable video'
                                            >
                                                <i
                                                    className={
                                                        videoDisable
                                                            ? "bi bi-camera-video-off-fill"
                                                            : "bi bi-camera-video-fill"
                                                    }
                                                ></i>
                                            </Button>
                                            {(isHandOffRoom || isQrTenantRoom) ?
                                                <Button
                                                    onClick={() => {
                                                        handleCameraSwap();
                                                    }}
                                                    variant={"secondary"}
                                                    title='Camera swap'
                                                >
                                                    <i className="bi bi-phone-flip"></i>
                                                </Button>
                                                :
                                                <>
                                                    {!isQrScanNotification &&
                                                        <Button
                                                            onClick={() => { setShowPopUp(true) }}
                                                            variant="secondary"
                                                            title="Call hand-off"
                                                        >
                                                            <i className="bi bi-share"></i>
                                                        </Button>
                                                    }
                                                    <Button
                                                        onClick={() => { setAddThirdUserFlag(true); }}
                                                        title="Add agent"
                                                        variant="secondary">
                                                        <i className="bi bi-person-plus-fill"></i>
                                                    </Button>
                                                </>
                                            }
                                            <Button
                                                className="video-timer"
                                                variant="secondary"
                                                disabled
                                            >
                                                {(
                                                    "0" +
                                                    Math.floor((timer / 60000) % 60)
                                                ).slice(-2)}
                                                :
                                                {(
                                                    "0" +
                                                    Math.floor((timer / 1000) % 60)
                                                ).slice(-2)}
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <video-player-container class="video-container-wrap">
                                    <div className="ml-auto Participant-video-frame px-4">
                                        {zoomLocalParticipant?.map((user: any) => {
                                            return (
                                                <div
                                                    className="video-cell localParticipantKioskClass"
                                                    key={user.userId}
                                                    //    style={ user.bVideoOn ? {"aspectRatio": "16/9"} : { "background": "black","aspectRatio": "16/9"}}
                                                    style={videoOffIcon ? { "background": "black", "aspectRatio": "16/9" } : { "aspectRatio": "16/9" }}
                                                >
                                                    {user.bVideoOn ?
                                                        <div key={user.userGuid}>
                                                            <video-player
                                                                class="video-player localParticipantVideoCard"
                                                                ref={(element) => {
                                                                    setVideoPlayerRef(user.userId, element);
                                                                }}
                                                            />
                                                            <span>{audioDisable ? <i className="bi bi-mic-mute mute-icon"></i> : <></>} </span>
                                                        </div>

                                                        : <i className="bi bi-camera-video-off" style={{ "color": "white" }}></i>
                                                    }
                                                </div>
                                            );
                                        })}
                                    </div>
                                </video-player-container>
                            )
                        }
                        {agentName && (
                            <div className="kioskAgentName">
                                <p style={kioskColorInfo.current} className="AgentNameDisplay">
                                    You are connected with <b>{agentName}</b>
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            ) : (
                <div className="logo">
                    <img
                        src={vrm_large_logo}
                        className="vrm_large_logo"
                        alt="temp"
                    />
                </div>
            )
            }

            {
                (addThirdUserFlag) ?
                    <AppModal
                        title={""}
                        bodyText={""}
                        showCloseButton={true}
                        closeButtonEventEmitter={() => { setAddThirdUserFlag(false); }}
                    >
                        <Teams addAgentModel={true} addAgentModelCallBackFunction={(agentDetails: any) => { addThirdUsers(agentDetails) }} />
                    </AppModal>
                    :
                    <></>
            }
        </div >
    )

};

export default ZoomVideoRoom;